import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=aef3277a&"
import script from "./GameInfo.vue?vue&type=script&lang=js&"
export * from "./GameInfo.vue?vue&type=script&lang=js&"
import style0 from "./GameInfo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports